var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEmptystateMensagem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.377,
    height: 93.753,
    viewBox: "0 0 84.377 93.753",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3685",
    "data-name": "Caminho 3685",
    d: "M3,11.375V67.627A9.385,9.385,0,0,0,12.375,77H28.782L45.189,95.753,61.6,77H78a9.385,9.385,0,0,0,9.375-9.375V11.375A9.385,9.385,0,0,0,78,2H12.375A9.385,9.385,0,0,0,3,11.375Zm37.5,4.688h9.375V44.189H40.5Zm0,37.5h9.375v9.375H40.5Z",
    transform: "translate(-3 -2)",
    fill: "#e8e8e8",
    stroke: "#000",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEmptystateMensagem);
export default __webpack_public_path__ + "static/media/ico-emptystate-mensagem.31f0b6b038d2e72f8eadcffdb53ee303.svg";
export { ForwardRef as ReactComponent };